import { USER_RESET_PASSWORD } from './index'

export const beginResetPassword = ([form]) => ({
  type: USER_RESET_PASSWORD.BEGIN,
  payload: { form },
})

export const successResetPassword = (data) => ({
  type: USER_RESET_PASSWORD.SUCCESS,
  payload: { data },
})

export const errorResetPassword = (error) => ({
  type: USER_RESET_PASSWORD.ERROR,
  payload: { error },
})
